import {
  ACESFilmicToneMapping,
  PCFSoftShadowMap,
  SRGBColorSpace,
  Vector3,
} from 'three';
import Stats from 'stats.js';
import { QUALITY_PRESETS } from '../config.js';

const QUALITY_NAMES = new Set(Object.keys(QUALITY_PRESETS));

export function detectQuest(userAgent = navigator.userAgent) {
  return /OculusBrowser|Meta Quest|Quest 2|Quest 3/i.test(userAgent);
}

export function selectQualityLevel() {
  const requested = new URLSearchParams(window.location.search).get('quality')?.toUpperCase();
  if (QUALITY_NAMES.has(requested)) return requested;
  return detectQuest() ? 'MEDIUM' : 'HIGH';
}

export function configureRenderer(renderer, qualityName) {
  const quality = QUALITY_PRESETS[qualityName] ?? QUALITY_PRESETS.MEDIUM;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, quality.maxPixelRatio));
  renderer.outputColorSpace = SRGBColorSpace;
  renderer.toneMapping = ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.05;
  renderer.shadowMap.enabled = quality.shadows;
  renderer.shadowMap.type = PCFSoftShadowMap;
  renderer.xr.enabled = true;
  return quality;
}

export class PerformanceMonitor {
  constructor(renderer, camera, playerRig) {
    this.renderer = renderer;
    this.camera = camera;
    this.playerRig = playerRig;
    this.lastDetailsUpdate = 0;
    this.position = new Vector3();
    this.stats = new Stats();
    this.stats.showPanel(0);
    this.stats.dom.classList.add('stats-panel');

    this.details = document.createElement('pre');
    this.details.className = 'debug-details';
    this.details.setAttribute('aria-label', 'Métricas de rendimiento WebGL');
    document.body.append(this.stats.dom, this.details);
  }

  begin() {
    this.stats.begin();
  }

  end(time) {
    this.stats.end();
    if (time - this.lastDetailsUpdate < 250) return;

    this.lastDetailsUpdate = time;
    this.camera.getWorldPosition(this.position);
    const info = this.renderer.info;
    this.details.textContent = [
      `Draw calls  ${info.render.calls}`,
      `Triángulos  ${info.render.triangles}`,
      `Geometrías  ${info.memory.geometries}`,
      `Texturas    ${info.memory.textures}`,
      `Cámara      ${this.position.x.toFixed(2)}, ${this.position.y.toFixed(2)}, ${this.position.z.toFixed(2)}`,
      `PlayerRig   ${this.playerRig.position.x.toFixed(2)}, ${this.playerRig.position.y.toFixed(2)}, ${this.playerRig.position.z.toFixed(2)}`,
    ].join('\n');
  }

  setVisible(visible) {
    this.stats.dom.hidden = !visible;
    this.details.hidden = !visible;
  }

  dispose() {
    this.stats.dom.remove();
    this.details.remove();
  }
}
